export default class {

    constructor(component) {

        const me = this,
            onResize = () => {

            const
                {
                    width,
                    height
                } = this.size;

            component.width = width,
            component.height = height ;
        }

        onResize() ;

       window.addEventListener('resize' , onResize) ;

       me.onResize = onResize ;

    }


    get size(){

        const
            body = document.querySelector('#box-body'),
            {
                width,
                height
            } = body.getBoundingClientRect() ;

        return {
            width:width - 20 - 32,
            height:height - 20 - 32
        }
    }

    onDestroyed(){

        window.removeEventListener('resize' , this.onResize) ;
    }

}